module.exports = __webpack_public_path__ + "static/img/sysj.6d0e286.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/sysj.png
// module id = qYmw
// module chunks = 0